const styles = {
  textField: {
    minWidth: { xs: "auto", md: 400 },
    my: 1,
  },
};

export default styles;
